import { MoonOutlined, SunOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import React from "react";
import { useTheme } from "../lib/ThemeContext";

interface ThemeToggleProps {
  size?: "small" | "middle" | "large";
  showText?: boolean;
  className?: string;
}

export const ThemeToggle: React.FC<ThemeToggleProps> = ({
  size = "middle",
  showText = false,
  className,
}) => {
  const { mode, toggleTheme } = useTheme();
  return null;

  return (
    <Tooltip title={`Switch to ${mode === "light" ? "dark" : "light"} mode`}>
      <Button
        type="text"
        size={size}
        icon={mode === "light" ? <MoonOutlined /> : <SunOutlined />}
        onClick={toggleTheme}
        className={className}
        aria-label={`Switch to ${mode === "light" ? "dark" : "light"} mode`}
      >
        {showText && (mode === "light" ? "Dark Mode" : "Light Mode")}
      </Button>
    </Tooltip>
  );
};

export default ThemeToggle;
